import { useAuthState } from '@auth/hooks';
import { UserRoles } from '@core/domain';
import type { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';

interface ModerationGuardProps {
  children: ReactNode;
}

/**
 * Route guard for moderation pages
 * Requires MODERATOR or ADMIN role for the specific community
 */
export function ModerationGuard({ children }: ModerationGuardProps) {
  const { communityId } = useParams<{ communityId: string }>();
  const { hasRoleAccess, user } = useAuthState();

  // Get the community's group ID from loaded communities if needed
  // For now, checking against undefined group (will need enhancement)
  const hasAccess = hasRoleAccess(UserRoles.MODERATOR, undefined, communityId) || hasRoleAccess(UserRoles.ADMIN, undefined, communityId);

  if (!user) {
    return <Navigate replace to="/login" />;
  }

  if (!hasAccess) {
    return <Navigate replace to="/" />;
  }

  return children;
}
